import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "geo-item-search land-ap-emergency" }

import GeoItemSearchCommon from 'src/components/Top/geoItemSearchComponents/GeoItemSearchCommon.vue';
import type { CommonSearchParams } from 'src/models/geoItemSearch';
import { emergencyTypeMap, emergencyTypes } from 'src/consts/ext_land_emergencies';
import { ref } from 'vue';
import type { EmergencyIndexParams } from 'src/models/apis/extLandApEmergency/extLandApEmergencyRequest';

const checkboxKeyPrefix = 'emg';
// 初期表示は「緊急」だけチェック

export default /*@__PURE__*/_defineComponent({
  __name: 'GeoItemSearchLandApEmergency',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const emergencyTypesDefaultValues = [1];
const commonSearchParams = ref<CommonSearchParams | null>(null);
// methods
const getSearchParams = (): EmergencyIndexParams | null => {
  if (!commonSearchParams.value) return null;

  const {
    searchTypes: movieTypes,
    tsFrom: startTs,
    tsTo: endTs,
    ...other
  } = commonSearchParams.value;
  return {
    movie_types: movieTypes as number[],
    start_ts: startTs,
    end_ts: endTs,
    road_names: other.roadNameDisps,
    directions: other.directions,
    kp_calc_from: other.kpCalcFrom,
    kp_calc_to: other.kpCalcTo,
  };
};
const onChange = () => {
  emit('change');
};

__expose({ getSearchParams });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GeoItemSearchCommon, {
      "search-params": commonSearchParams.value,
      "onUpdate:searchParams": _cache[0] || (_cache[0] = ($event: any) => ((commonSearchParams).value = $event)),
      "checkbox-key-prefix": checkboxKeyPrefix,
      "search-types": _unref(emergencyTypes),
      "search-type-map": _unref(emergencyTypeMap),
      "search-type-default-values": emergencyTypesDefaultValues,
      "default-days-before": 7,
      onChange: onChange
    }, null, 8, ["search-params", "search-types", "search-type-map"])
  ]))
}
}

})